<template>
  <a-icon-sheet-card
    title="Recruiting.Dashboard.JobPostingsTitle"
    :count="data.count"
  >
    <div
      v-if="noJobPostings()"
      v-t="'Recruiting.Dashboard.JobPostingsNoJobPostings'"
      class="p-3"
    />
    <ul v-else class="list-group list-group-flush">
      <li
        v-for="(item, index) in data.jobPostings"
        :key="index"
        class="list-group-item dashboard-dashlet-list-item action-item"
        @click="itemClicked(item)"
      >
        <a-dashlet-list-item-title>
          <span slot="title" v-text="item.name" />
          <span slot="addition">
            {{
              $t("Recruiting.Dashboard.JobPostingsEnd", [
                $dtFormat(new Date(item.endOfPublication))
              ])
            }}
          </span>
        </a-dashlet-list-item-title>
        <div class="row text-pf-muted">
          <div
            v-t="'Recruiting.Dashboard.JobPostingsJobApplications'"
            class="col py-0"
          />
          <div class="col-auto py-0 text-end">
            <span
              class="fw-bold me-1"
              v-text="item.countOwnOpenJobApplications"
            />
            <span v-t="'Recruiting.Dashboard.JobPostingsOpen'" />
          </div>
          <div class="col-auto py-0 text-end">
            <span
              class="fw-bold me-1"
              v-text="item.countOwnDoneJobApplications"
            />
            <span v-t="'Recruiting.Dashboard.JobPostingsDone'" />
          </div>
        </div>
        <a-progress-bar
          css-class="dashboard-job-posting-dashlet-progress-bar"
          :progress-value="item.progress"
        />
      </li>
    </ul>
    <template #actions>
      <a
        v-t="'Recruiting.Dashboard.ShowAll'"
        :disabled="empty"
        :class="{ 'text-pf-muted text-decoration-none': empty }"
        href="javascript:void(0)"
        @click="goToOverview()"
      />
    </template>
  </a-icon-sheet-card>
</template>

<script>
import IconSheetCard from "+/components/card/IconSheetCard";
import ProgressBar from "+/components/progressBar/ProgressBar";
import DashletListItemTitle from "~/recruiting-system/components/dashboard/DashletListItemTitle";

export default {
  components: {
    "a-icon-sheet-card": IconSheetCard,
    "a-progress-bar": ProgressBar,
    "a-dashlet-list-item-title": DashletListItemTitle
  },
  props: {
    data: { type: Object, default: () => {} }
  },
  computed: {
    empty: function () {
      return this.data.count < 1;
    }
  },
  methods: {
    noJobPostings() {
      return this.data.jobPostings.length == 0;
    },
    itemClicked(item) {
      const route = `/main/bm.ausschr/detail?refnr=${item.jobPostingId}&site=pubdetails`;
      this.$router.push(route);
    },
    goToOverview() {
      if (this.empty) {
        return;
      }
      const route = `/main/st.st_projekt`;
      this.$router.push(route);
    }
  }
};
</script>
